import React from 'react'
import {useTranslation} from 'react-i18next'
import type {
  PatientAppointmentItem,
  SlotStatusHistory,
  SlotStatusType,
  StatusUpdatedByRole,
} from '@common/models'
import {useEnumTranslations} from '@common/utils/translations'
import {EnumType} from '@common/utils/types'

import {HistoryList, HistoryItem} from './AppointmentManagementPage.styled'

import {Typography} from '~/components/general/typography/Typography'
import {Container} from '~/components/general/container/Container'
import {Modal} from '~/components/general/modal/Modal'

type SlotHistoryModalProps = {
  isVisible: boolean
  onClose: () => void
  openSlotId: string | null
  items: PatientAppointmentItem[] | undefined
}

export const SlotHistoryModal = ({
  isVisible,
  onClose,
  openSlotId,
  items,
}: SlotHistoryModalProps) => {
  const {t} = useTranslation()
  const {translateEnumValue} = useEnumTranslations()

  const item = items?.find(
    (i: PatientAppointmentItem) => i.slotId === openSlotId,
  )

  return (
    <Modal
      header={t('Slot history')}
      footer={null}
      isVisible={isVisible}
      onClose={onClose}>
      <Container direction="column" spacing={2}>
        {item && (
          <HistoryList>
            {(
              item.history as (SlotStatusHistory & {statusNote?: string})[]
            ).map((h, idx: number) => (
              <HistoryItem key={`${item.slotId}-${idx}`}>
                <Container justify="flex-end" align="center">
                  <Typography weight="bold">
                    {translateEnumValue(
                      EnumType.SlotStatusType,
                      h.status as SlotStatusType,
                      '-',
                    )}
                  </Typography>
                </Container>
                <Typography>
                  {t('Updated at')}: {h.at || '-'}
                </Typography>
                <Typography color="muted">
                  {t('Comment')}: {h.comment ?? '-'}
                </Typography>
                <Typography color="muted">
                  {t('By')}:{' '}
                  {translateEnumValue(
                    EnumType.StatusUpdatedByRole,
                    h.by as StatusUpdatedByRole | undefined,
                    '-',
                  )}
                </Typography>
              </HistoryItem>
            ))}
          </HistoryList>
        )}
      </Container>
    </Modal>
  )
}
